// List of flags that should be evaluated before first paint based on the user location
// These flags are duplicated in the backend

export const FF_CCPA_BANNER = 'ccpa-banner';

// FUN-18 CCPA banner
export const FF_CCPA_COOKIE_VARIANT = 'ccpa-cookie-banner';

// FUN-19 A/B test experiment
export const FF_HIDE_COOKIE_WALL = 'hide-cookie-wall';

export const FF_REJECT_BUTTON = 'reject-consent-button-visibility';
